import HotelImage, { HotelImageProps } from './hotelImage'

// No logic — passthrough kept for the two-file pattern.
const HotelImageWrapper = (props: HotelImageProps) => {
    return <HotelImage {...props} />
}

export { HotelImageWrapper }
export type { HotelImageProps }
export default HotelImageWrapper
